/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/prop-types */
import React from 'react';
// import PropTypes from 'prop-types';
import shortid from 'shortid';
// components
import Skeleton from '../../atoms/Skeleton/Skeleton';

import iconArrowRight from '../../../assets/img/icon-arrow-right.png';
import iconRedirect1 from '../../../assets/img/icon-redirect-1.svg';
import iconRedirect2 from '../../../assets/img/icon-redirect-2.svg';
import iconRedirect3 from '../../../assets/img/icon-redirect-3.svg';
import iconRedirect4 from '../../../assets/img/icon-redirect-4.svg';
import iconRedirect5 from '../../../assets/img/icon-redirect-5.svg';
import iconRedirect6 from '../../../assets/img/icon-redirect-6.svg';

const nameIcons = {
  13: iconRedirect1,
  14: iconRedirect2,
  15: iconRedirect3,
  16: iconRedirect4,
  17: iconRedirect5,
  18: iconRedirect6,
};

const AlreadyMember = (props) => {
  const { isLoadingRegisterSurvey, question, onSelectOption } = props;

  return (
    <section>
      <article className="m-0 px-7 py-5 border-bottom border-neutral-alfa-15">
        <h4>Ya eres socio Coopeuch</h4>
      </article>
      <article className="m-0 px-7 pt-6 pb-7">
        <p className="mb-4">
          Según nuestros registros, ya eres parte de Coopeuch. Dinos en qué podemos ayudarte:
        </p>
        <section className="grid-order-by-2-columns-3-rows">
          {question.alternatives.map((el) =>
            isLoadingRegisterSurvey !== null ? (
              <Skeleton height="32px" width="240px" mb={0} />
            ) : (
              <button
                className="btn-with-prefix-sufix btn-without-format"
                type="button"
                id={shortid.generate()}
                onClick={() =>
                  onSelectOption({
                    idOption: el.idOption,
                    // description: el.description,
                  })
                }
              >
                <img src={nameIcons[el.idOption]} width="32" height="32" alt="" />
                <p>{el.description}</p>
                <img src={iconArrowRight} width="16" height="16" alt="" />
              </button>
            )
          )}
        </section>
      </article>
    </section>
  );
};

export default AlreadyMember;
